import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectProfileIconComponent } from './select-profile-icon.component';
import { SharedModule } from 'src/app/shared.module';



@NgModule({
  declarations: [SelectProfileIconComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [SelectProfileIconComponent]
})
export class SelectProfileIconModule { }
